import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useCallback, useEffect } from 'react';
import { PRODUCT_LIST_MODULE_NAME } from '../cus-product-list.const';

interface UseLogProductListItemErrorParams {
    variantId: string | undefined;
    name: string | undefined;
    price: string | undefined;
    src: string | undefined;
    relativeUrl: string | undefined;
    telemetry: ITelemetry;
}

export const useLogProductListItemError = ({ variantId, name, price, src, relativeUrl, telemetry }: UseLogProductListItemErrorParams) => {
    const logItemError = useCallback(
        (message: string) => {
            const finalMessage = `[${PRODUCT_LIST_MODULE_NAME}] ProductListItem (variantId: ${variantId || 'unknown'}) encountered error during render: ${message}.`;
            telemetry.error(finalMessage);
            console.error(finalMessage);
        },
        [telemetry, variantId]
    );

    useEffect(() => {
        if (!variantId) {
            logItemError('Missing product variantId (concatenatedId)');
        }
        if (!name) {
            logItemError('Missing product name');
        }
        if (!price) {
            logItemError('Missing product price (finalPriceFormatted)');
        }
        if (!src) {
            logItemError('Missing product image src');
        }
        if (!relativeUrl) {
            logItemError('Missing product relativeUrl');
        }
    }, [variantId, name, price, src, relativeUrl, logItemError]);
};
